<template>
    <div class="mx-auto" style="width: 85%">
        <h2 class="text-md-center">About Me</h2>
        <b-list-group>
            <h3 class="bg-info text-center">Objective Statement</h3>
            <b-card no-body>
                <p>Combine and pave the way in technology and current scientific research</p>
            </b-card>
            <h3 class="bg-info text-center">Education</h3>
            <b-card no-body>
                <b-img center fluid class="img-item-style" :alt="'Ohio Wesleyan Logo'"
                       :src="require('../assets/imgs/Ohio Wesleyan.png')"/>
                <ul>
                    <li>Bachelor of Arts Degree: Microbiology</li>
                    <li>Minor Degree: Computer Science with a focus in data analytics and machine learning</li>
                    <li>GPA: 3.5</li>
                    <li>College: Ohio Wesleyan University</li>
                </ul>
            </b-card>
            <h3 class="bg-info text-center">Contact Information</h3>
            <b-card no-body>
                <p>Email: <a href="mailto:aidangshumaker@gmail.com">aidangshumaker@gmail.com</a></p>
                <p>Phone: 513-582-8754</p>
            </b-card>
            <h3 class="bg-info text-center">Download Resume</h3>
            <b-card no-body>
                <a href="https://drive.google.com/open?id=1uH3NR1ZdAx-IjprwRvRevujIkaRdcrl6"
                target="_blank">
                    <b-img center fluid class="img-item-style" :alt="'Resume'"
                           :src="require('../assets/imgs/Resume.png')"/>
                </a>
            </b-card>
        </b-list-group>
    </div>
</template>

<script>
    export default {
        name: "Me"
    }
</script>

<style scoped>

</style>
